/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function dropdown() {
    const listenerContainers = document.querySelectorAll(".language-page-selector, .language-page-selector--mobile");
    
    const init = function () {
        listenerContainers.forEach((btn) => {
            btn.addEventListener("click", function () {
                const dropdown = btn.querySelector("#languageSelector");
                if (!dropdown) return;

                // If the dropdown is currently open, close it
                if (dropdown.style.height && dropdown.style.height !== "0px") {
                    dropdown.style.height = "0px";
                } else {
                    // Open it by setting the content height
                    dropdown.style.height = `${dropdown.scrollHeight}px`;
                }
            });
        });
    };

    init();
}